<template>
  <v-dialog v-model="dialog" max-width="750">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        dark
        v-bind="attrs"
        v-on="on"
        class="mb-4"
        :disabled="isDisabled"
      >
        <v-avatar
          :style="{ backgroundColor: isDisabled ? '#aaa' : '#27362F' }"
          class="pa-2 cursor-pointer"
          @click="openMenuPrinter"
        >
          <img src="@/assets/i/icon-printer-w.svg" />
        </v-avatar>
      </v-btn>
    </template>
    <v-stepper alt-labels v-model="stepper">
      <v-stepper-header>
        <v-stepper-step step="1">
          Records
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">
          Tag Type
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">
          Tag Format
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">
          Order / Print
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-content step="1">
        <v-card flat>
          <v-card-text class="py-0">
            <v-data-table
              :headers="headers"
              :items="records"
              :items-per-page="5"
            >
              <template v-slot:[`item.quantity`]="props">
                <v-edit-dialog
                  :return-value.sync="props.item.quantity"
                  class="py-0"
                >
                  {{ props.item.quantity }}
                  <template v-slot:input>
                    <v-text-field
                      v-model.number="props.item.quantity"
                      label="Edit"
                      single-line
                      counter
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn color="#717C7D" text @click="closeDialog">Cancel</v-btn>
            <v-btn color="primary" @click="next">Next</v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-card>
          <v-card-title class="py-0">Select Tag</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 230px">
            <v-select
              v-if="tags.length > 0"
              :items="tags"
              item-text="tag_type.reference"
              item-value="tag_type.id"
              v-model="selectedTag"
              prefix="Tag Type :   "
            ></v-select>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="#717C7D" text @click="handleBack">Back</v-btn>
            <v-btn color="#717C7D" text @click="closeDialog">Cancel</v-btn>
            <v-btn color="primary" @click="next" :disabled="!selectedTag">
              Next
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="3">
        <v-card>
          <v-card-title class="py-0">Select Format</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 230px">
            <v-select
              v-if="tagFormats.length > 0"
              :items="tagFormats"
              item-text="tag_format.description"
              item-value="tag_format.id"
              v-model="selectedTagFormat"
              prefix="Tag Format :   "
            ></v-select>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="#717C7D" text @click="handleBack">Back</v-btn>
            <v-btn color="#717C7D" text @click="closeDialog">Cancel</v-btn>
            <v-btn color="primary" @click="next" :disabled="!selectedTagFormat">
              Next
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="4">
        <v-card>
          <v-card-title class="py-0">Select Order/Print</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 100%">
            <v-radio-group v-model="type" @change="changeType" column>
              <v-row>
                <v-col cols="6">
                  <v-radio
                    value="order"
                    :label="$t('lang.inbound.dashboard.label_order')"
                    color="#9ac31c"
                  ></v-radio>
                </v-col>
                <v-col cols="6">
                  <v-radio
                    value="print"
                    :label="$t('lang.inbound.dashboard.label_print')"
                    color="#9ac31c"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-row class="mt-n6">
              <v-col></v-col>
              <v-col>
                <v-select
                  :items="printers"
                  item-text="description"
                  item-value="id"
                  v-model="selectedPrinter"
                  :disabled="!type || type !== `print`"
                  :label="$t('lang.inbound.dashboard.label_printer')"
                  outlined
                  hide-details="auto"
                  dense
                ></v-select>

                <v-row
                  class="print-qty mt-3 py-0 h-auto"
                  style="width: 100% !important"
                  aria-disabled="true"
                >
                  <v-radio-group
                    v-model="qtyGroup"
                    class="m-0 p-0"
                    hide-details
                  >
                    <v-col>
                      <v-radio
                        value="all"
                        :label="$t('lang.inbound.dashboard.label_all')"
                        color="#9ac31c"
                        class="mb-0"
                        :disabled="
                          !type || type !== `print` || !selectedPrinter
                        "
                      ></v-radio>
                    </v-col>
                    <v-col class="d-flex flex-row align-center">
                      <v-radio
                        value="qty"
                        :label="$t('lang.inbound.dashboard.label_from')"
                        color="#9ac31c"
                        class="mb-0"
                        :disabled="
                          !type || type !== `print` || !selectedPrinter
                        "
                      >
                      </v-radio>
                      <v-text-field
                        type="number"
                        :rules="rules"
                        :value="qtyFrom"
                        v-model="qtyFrom"
                        outlined
                        dense
                        class="px-0 pl-2"
                        :disabled="
                          !type ||
                            type !== `print` ||
                            !selectedPrinter ||
                            qtyGroup !== 'qty'
                        "
                      ></v-text-field>
                      <span
                        class="mx-2"
                        :style="{
                          color:
                            !type ||
                            type !== `print` ||
                            !selectedPrinter ||
                            qtyGroup !== 'qty'
                              ? '#aaa'
                              : '#000'
                        }"
                        >to</span
                      >
                      <v-text-field
                        type="number"
                        :rules="rules"
                        :value="qtyTo"
                        v-model="qtyTo"
                        outlined
                        dense
                        class="p-0"
                        :disabled="
                          !type ||
                            type !== `print` ||
                            !selectedPrinter ||
                            qtyGroup !== 'qty'
                        "
                      ></v-text-field>
                    </v-col>
                  </v-radio-group>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="#717C7D" text @click="handleBack">Back</v-btn>
            <v-btn color="#717C7D" text @click="closeDialog">Cancel</v-btn>
            <v-btn color="primary" @click="next" :disabled="checkIsDisabled">
              {{ nextBtnLabel }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper>
  </v-dialog>
</template>

<script>
import moment from "moment";

export default {
  async mounted() {
    this.user = await this.$api.printer.printer_user(
      this.$store.state.user.user
    );
  },
  data() {
    return {
      user: null,
      loading: false,
      printers: [],
      tagFormats: [],
      tags: [],
      selectedTag: null,
      type: null,
      qtyGroup: "all",
      selectedPrinter: null,
      selectedTagFormat: null,
      company: null,
      printerCompany: null,
      companyFormat: null,
      itemsPerPage: process.env.VUE_APP_GTIN_PER_PAGE,
      page: 1,
      totalQuqntity: 0,
      items: [],
      qtyFrom: 1,
      qtyTo: 500,
      rules: [
        v => !!v || this.$t("lang.inbound.dashboard.error_required"),
        v => v > 0 || this.$t("lang.inbound.dashboard.error_min"),
        v => v <= 500 || this.$t("lang.inbound.dashboard.error_max")
      ],
      dialog: false,
      printer: "",
      stepper: 1,
      headers: [
        {
          text: "GTIN",
          align: "start",
          sortable: false,
          value: "gtin"
        },
        {
          text: "Quantity",
          align: "end",
          value: "quantity"
        }
      ]
    };
  },
  props: {
    order_num: Number,
    isDisabled: Boolean,
    records: Array
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    handleBack() {
      this.stepper -= 1;
      if (this.stepper === 3) {
        this.type = null;
        this.selectedPrinter = null;
      }
    },
    async openMenuPrinter() {
      this.printers = await this.$api.porders.printers();
      this.dialog = true;
      this.stepper = 1;
    },
    closeDialog() {
      this.stepper = 1;
      this.type = null;
      this.selectedTag = null;
      this.selectedPrinter = null;
      this.company = null;
      this.printerCompany = null;
      this.companyFormat = null;
      this.totalQuqntity = 0;
      this.items = [];
      this.dialog = false;
    },
    async changeType() {
      this.isLoad = false;
      const porder = await this.$api.porders.report(this.order_num, {});
      const items = porder.map((order, i) => {
        const obj = { ...order, quantity: order.real_quantity };
        return { ...obj };
      });
      const selectedGTIN = this.records.map(i => i.gtin);
      this.items = items.filter(i => selectedGTIN.includes(i.gtin));
      const total_quantity = this.items.reduce((acc, val) => {
        return acc + val.theorical_quantity;
      }, 0);
      this.totalQuantity = total_quantity;
      this.isLoad = false;
    },
    async next() {
      if (this.stepper < 4) {
        ++this.stepper;
      }
      if (this.stepper === 2) {
        this.loading = true;
        this.tags = await this.$api.printer.printer_tagtype();
        this.loading = false;
      }
      if (this.stepper === 3) {
        this.loading = true;
        this.tagFormats = await this.$api.printer.printer_tagtype({
          tag_type: this.selectedTag
        });
        this.loading = false;
      }
      if (this.stepper === 4) {
        this.printers = [];
        this.printers = await this.$api.printer.printer_list();
        this.printerCompany = await this.$api.printer.getPrinterCompany();
        this.companyFormat = await this.$api.printer.printer_tagtype({
          tag_type: this.selectedTag,
          tag_format: this.selectedTagFormat,
          limit: 10
        });

        if (this.type === "print") {
          this.company = await this.$api.printer.getPrinterCompanyByFilter(
            "CLIENT"
          );
          const res = await this.$api.printer.set_print_order({
            companyformat_id: this.companyFormat.results[0].id,
            responsible_id: this.user.company,
            total_quantity: this.totalQuantity,
            items: this.items
          });
          if (this.selectedPrinter && res) {
            const payload = {
              printorder_id: res.print_order,
              print_id: this.selectedPrinter,
              from: this.qtyFrom,
              to: this.qtyTo
            };
            if (this.qtyGroup === "all") {
              delete payload.from;
              delete payload.to;
            }
            await this.$api.printer.printer_print(payload);
            await this.$api.printer
              .printer_tagtype({
                tag_type: this.selectedTag,
                tag_format: this.selectedTagFormat
              })
              .then(() => (this.showSideMenu = "printer_menu"));

            this.$router.push({
              name: "PrintOrderList",
              params: { printer: this.selectedPrinter }
            });
          }
        } else if (this.type === "order") {
          this.company = await this.$api.printer.getPrinterAdminCompany();
          if (this.company && this.companyFormat) {
            await this.$api.printer.set_print_order({
              companyformat_id: this.companyFormat.results[0].id,
              responsible_id: this.company[0].id,
              total_quantity: this.totalQuantity,
              items: this.items
            });
          }
          await this.$api.printer
            .printer_tagtype({
              tag_type: this.selectedTag,
              tag_format: this.selectedTagFormat,
              limit: 10
            })
            .then(() => (this.showSideMenu = "printer_menu"));

          this.$router.push({
            name: "PrintOrderList",
            params: {
              printer: this.selectedPrinter,
              id: this.records[0].id
            }
          });
          this.closeDialog();
        }
      }
    },
    async print() {
      try {
        var date = new Date();
        var printingIdentifier = await this.$api.printer.printingIdentifier(
          this.printer,
          this.formatDate(date)
        );
        this.records.forEach(record => {
          this.$api.printer.print(
            printingIdentifier,
            record.itemType,
            record.quantity
          );
        });
      } catch (error) {
        console.error("error", error);
      } finally {
        this.dialog = false;
      }
    }
  },
  computed: {
    nextBtnLabel() {
      if (this.stepper && this.stepper === 4 && this.type === "print") {
        return this.$t("lang.inbound.dashboard.label_print");
      } else {
        return this.$t("lang.inbound.dashboard.btn_next");
      }
    },
    showSideMenu: {
      get() {
        return this.$store.getters.showSideMenu;
      },
      set(data) {
        this.$store.dispatch("setSideMenu", data);
      }
    },

    checkIsDisabled() {
      if (
        (this.stepper === 4 && this.type === "order") ||
        (this.stepper === 4 &&
          this.type === "print" &&
          this.selectedPrinter !== null)
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style></style>
